"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringListStyleName = exports.EllipsedStyleName = exports.ListStyleName = exports.ListIsActiveClass = exports.MenuItemCheck = exports.ListAndMenuItemHeight = exports.ListAndMenuPadding = void 0;
var tslib_1 = require("tslib");
var raw_1 = require("@tableau/icons/NotificationCheckIcon/raw");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Icons_1 = require("../../icons/Icons");
var Colors_1 = require("../../styles/Colors");
var Flexbox_1 = require("../../styles/Flexbox");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Colors = TabStyles_1.TabStyles.Colors, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
exports.ListAndMenuPadding = 6;
exports.ListAndMenuItemHeight = 24;
var MenuItemCheck = function (fill) {
    if (fill === void 0) { fill = Colors_1.IconFillColors.Rest; }
    return Icons_1.encodeSvg(raw_1.NotificationCheckIconRaw(12, fill));
};
exports.MenuItemCheck = MenuItemCheck;
exports.MenuItemCheck.size = 12;
var InternalIconPadding = 1; // svg includes 1px of padding
exports.ListIsActiveClass = 'listIsActive';
exports.ListStyleName = TypeStyle.style(PreventUserSelect_1.PreventUserSelect, {
    boxSizing: 'border-box',
    color: Colors_1.ListAndMenuColors.Text,
    fontSize: Typography.Sizing.Default,
    lineHeight: 'normal',
    overflowY: 'auto',
    padding: exports.ListAndMenuPadding,
    '-webkit-overflow-scrolling': 'touch',
    $nest: (_a = {
            '&:focus': { outline: 'none' },
            '&::-moz-focus-inner': { $unique: true, border: 'none' },
            '&:focus-visible': FocusIndicators_1.DefaultFocusIndicator(),
            '& [role="separator"]': {
                background: Colors.F3,
                height: 1,
                margin: '8px 0',
            },
            '& [role="group"] > :first-child': tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.AlignItemsCenter), Flexbox_1.DisplayFlex), { fontWeight: 'bold', minHeight: exports.ListAndMenuItemHeight }),
            '& [role="option"]': tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.AlignItemsCenter), Flexbox_1.DisplayFlex), { backgroundRepeat: 'no-repeat', backgroundPosition: Spacing.DefaultSpace - InternalIconPadding + "px " + (exports.ListAndMenuItemHeight - exports.MenuItemCheck.size) / 2 + "px", borderRadius: 2, minHeight: exports.ListAndMenuItemHeight, paddingLeft: exports.MenuItemCheck.size - InternalIconPadding + (Spacing.DefaultSpace * 2), paddingRight: Spacing.DefaultSpace, $nest: {
                    '&[aria-checked="true"]': { backgroundImage: "url('" + exports.MenuItemCheck(Colors_1.IconFillColors.Hover) + "')" },
                    '&:hover': {
                        backgroundColor: Colors_1.ListAndMenuColors.Hover,
                        outline: "1px solid " + Colors_1.ListAndMenuColors.ActiveBorder,
                        outlineOffset: -1,
                    },
                    '&[aria-disabled="true"]': {
                        backgroundColor: 'transparent',
                        color: Colors_1.ListAndMenuColors.DisabledTextWithOpacity,
                        outlineColor: 'transparent',
                        opacity: Colors_1.ListAndMenuColors.Opacity,
                    },
                } }),
            // the selector for pressed state needs to be at least the same specificity as the selector for aria-selected in order to override properly
            '&& [role="option"]:active': {
                backgroundColor: Colors_1.ListAndMenuColors.Press,
                outline: "1px solid " + Colors_1.ListAndMenuColors.ActiveBorder,
                outlineOffset: -1,
            }
        },
        _a["&:focus [role=\"option\"][aria-selected=\"true\"], &." + exports.ListIsActiveClass + " [role=\"option\"][aria-selected=\"true\"]"] = {
            backgroundColor: Colors_1.ListAndMenuColors.Active,
            outline: "1px solid " + Colors_1.ListAndMenuColors.ActiveBorder,
            outlineOffset: -1,
        },
        // eslint-disable-next-line max-len
        _a["&:focus [role=\"option\"][aria-selected=\"true\"][aria-disabled=\"true\"], &." + exports.ListIsActiveClass + " [role=\"option\"][aria-selected=\"true\"][aria-disabled=\"true\"]"] = {
            backgroundColor: 'transparent !important',
            outline: "1px solid " + Colors_1.ListAndMenuColors.DisabledBorder + " !important",
        },
        _a)
});
exports.EllipsedStyleName = TypeStyle.style(Flexbox_1.FlexGrow1, TextEllipsis_1.TextEllipsis);
exports.FilteringListStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, Flexbox_1.DisplayFlex), Flexbox_1.FlexDirectionColumn), { boxSizing: 'border-box', lineHeight: 'normal', $nest: {
        '&.reverse': tslib_1.__assign({}, Flexbox_1.FlexDirectionColumnReverse),
        '&:focus-visible, & :focus-visible': FocusIndicators_1.DefaultFocusIndicator(),
    } }));
//# sourceMappingURL=ListStyles.js.map